export const enWebsiteNode = {
  back: "Back",
  coldStatus: "Cold",
  forward: "Forward",
  reload: "Reload",
  close: "Close",
  urlPlaceholder: "Enter URL",
  loadFailed: "Page failed to load"
};
